import { defineStore } from 'pinia'

// "product": 1, //1-Live, 3-Prematch, 5-PremiumCricket, 6-VirtualFootball, 10-VirtualDogRace, 11-VirtualHorseRace, 12-VirtualLiveTennis
// "status": 0 //1为 DOWN，0为 UP
const PRODUCT_LIVE = 1
const PRODUCT_PREMATCH = 3
const STATUS_DOWN = 1

export const useRealSportsStore = defineStore('realsports', {
  state: () => ({
    // 产品可投状态
    productDownStatus: {
      live: false,
      prematch: false
    }
  }),
  getters: {
    // 产品全部不可投
    productDown() {
      return this.productDownStatus.prematch && this.productDownStatus.live
    },
    productDownOfLive() {
      return this.productDownStatus.live
    }
  },
  actions: {
    updateProductDownStatusOfLive(status) {
      this.productDownStatus.live = status === STATUS_DOWN
    },
    updateProductDownStatusOfPrematch(status) {
      this.productDownStatus.prematch = status === STATUS_DOWN
    },
    updateProductStatus(productStatus = []) {
      if (productStatus?.length) {
        productStatus.forEach(({ product, status }) => {
          if (PRODUCT_LIVE === product) {
            this.updateProductDownStatusOfLive(status)
          }
          if (PRODUCT_PREMATCH === product) {
            this.updateProductDownStatusOfPrematch(status)
          }
        })
      }
    }
  }
})
